import { useQuery } from '@tanstack/react-query'
import { BranchesService } from '@/shared/api/rest/services/branches.service'
import { BranchRecord } from '@/shared/api/rest/types'

export type BranchType = {
    value: string
    label: string
}

/**
 * useBranches - returns all church branches from the REST backend.
 * @returns {branches: BranchType[], loading: boolean}
 */
function useBranches() {
    const { data, isLoading, error } = useQuery({
        queryKey: ['branches'],
        queryFn: () => BranchesService.list()
    })

    if (!data || error) {
        return { loading: isLoading, branches: [] as BranchType[] }
    }

    const branches: BranchType[] = data.map((branch: BranchRecord) => ({
        value: branch._id,
        label: branch.name
    }))

    return { branches, loading: isLoading }
}

export { useBranches }
